<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>VIEW - BREEDS MANAGEMENT</h2>
       <p>Breeds details</p>
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
      </div>
       <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12">
       <div class="grid_view">
       <h3>&nbsp;</h3>
       <div class="card mt-0">
       <div class="card-body">
       <div class="row">
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Breeds Name:&nbsp;</span><span id="breedsviewName"></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Breed ID:&nbsp;</span ><span id="breedsviewId"></span></p>
        </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Farm Name:&nbsp;</span ><span id="breedsfarmname"></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Species Name:&nbsp;</span ><span id="breedsSpeciesID"></span></p>
        </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Status:&nbsp;</span ><span id="breedsStatus"></span></p>
        </div>
       </div>
       </div>
       </div>
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <button type="submit"  (click)='breedsmanagement()' class="btn btn-fill btn-primary mb-3">
        Back <div class="ripple-container"></div>
       </button>
       <br>
       <!--<button type="submit" class="btn btn-fill btn-default">
        Cancel <div class="ripple-container"></div>
       </button>-->
       </div>
       </div>
     </div>
   </div>
 </div>
